import { fillString } from '@local_modules/generic/string-template.js'
import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import htmlTemplate from './index.html'
import dayjs from 'dayjs'

export function showDetails (params) {
  console.log('showDetails', params)

  const { containerElementId, dataSyncApiResponse } = params

  let html = htmlTemplate

  html = fillString(html, {
    organisationName: showOrganisationName(dataSyncApiResponse.accounting_organisation),
    status: tagStatus(dataSyncApiResponse.status),
    origin: dataSyncApiResponse.origin,
    createdAt: formatTime(dataSyncApiResponse.created_at),
    scheduledTime: formatTime(dataSyncApiResponse.scheduled_time),
    startedAt: formatTime(dataSyncApiResponse.started_at),
    endedAt: formatTime(dataSyncApiResponse.ended_at),
    modules: dataSyncApiResponse.data_sync_modules.length,
    steps: dataSyncApiResponse.data_sync_steps.length,
    errors: dataSyncApiResponse.data_sync_errors.length
  })

  setElementHtml(containerElementId, html)
}

function showOrganisationName (accountingOrganisation) {
  return `
    ${accountingOrganisation.name} 
    <a href="/app/admin/data-syncs?accountingOrganisationId=${accountingOrganisation.id}">List of syncs</a>
    <a href="/app/admin/entity/${accountingOrganisation.id}">Entity Admin</a>
  `
}

function tagStatus (status) {
  let tag = 'is-info'
  if (status === 'ongoing') tag = 'is-warning'
  if (status === 'done') tag = 'is-success'
  if (status === 'failed') tag = 'is-danger'

  return `<span class="tag ${tag}">${status}</span>`
}

function formatTime (timestamp) {
  if (!timestamp) return ''
  return dayjs(timestamp).format('YYYY-MM-DD @ HH:mm:ss')
}
